var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-list',{attrs:{"finished":_vm.finished,"finished-text":"没有更多数据了","loading-text":"数据加载中..."},on:{"load":_vm.onLoad},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},_vm._l((_vm.list),function(item,index){return _c('div',{key:index},[_vm._t("item",null,{"item":item})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }